import {useFeaturePermission} from '../contexts/FeatureBoundary';
import ACCOUNT_TAB from '../constants/AccountTab';
import {GlobalPermissionEnum} from '../schema-types/globalTypes';

/**
 * Resolves the correct route paths for the recommendation flow based on whether
 * the user has access to the dentist recommendation builder.
 *
 * - Users with the dentist builder permission are routed to the newer builder
 *   experience (`builder` / `requirements-builder`).
 * - All other users fall back to the BAU recommendation flow
 *   (`recommends-builder` / `requirements`).
 */
export const useRequirementsDentistOrBAU = () => {
  const hasDentistBuilderPerm = useFeaturePermission([
    GlobalPermissionEnum.can_access_dentist_recommendation_builder,
  ]);

  const createRecommendUrl = hasDentistBuilderPerm ? 'builder' : 'recommends-builder';

  // Typed as string (rather than the ACCOUNT_TAB enum) so callers/mocks can keep treating
  // it as a plain route segment.
  const recommendsGridUrl: string = hasDentistBuilderPerm
    ? ACCOUNT_TAB.NEW_INSTRUCTIONS
    : ACCOUNT_TAB.INSTRUCTIONS;

  return {
    createRecommendUrl,
    recommendsGridUrl,
  };
};
